import { Component } from '@angular/core';
import { CurrentUserService } from '@services/current-user.service';
import { UserMenusService } from '@services/user-menus.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'vnm-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent {
  firstName$ = this.currentUser.user$.pipe(map(({ firstName }) => firstName));

  constructor(public currentUser: CurrentUserService, public userMenus: UserMenusService) {}
}
